import React from 'react';
import { LanguageSelectIcon } from '@components/LanguageSelect';

export const FlagIcon = ({ language }: { language: string }) => (
  <LanguageSelectIcon
    code={language}
    className={'eye:border eye:border-grey-20 eye:w-[36px] eye:h-[25px]'}
  />
);

FlagIcon.displayName = 'FlagIcon';
